import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ui-blocking-layer',
    template: `
        <button *ngIf="dismissable" (click)="close()" ui-button>close</button>
        <div class="overlayer-content"><ng-content></ng-content></div>`,
    styleUrls: ['./ui-blocking-layer.component.scss'],
    host: {
        '[class.blocking-overlayer]': 'true'
    }
})
export class UiBlockingLayerComponent {

    open = true;
    @Input() dismissable = false;

    @Output() dismiss: EventEmitter<boolean> = new EventEmitter();

    close() {
        this.open = false;
        this.dismiss.emit(this.open);
    }

}
